:host {
  display: block;
  margin-right: css-var(components-margin-left-right);
  margin-left: css-var(components-margin-left-right);
  margin-bottom: css-var(components-mb);
}

.video-play-icon {
  background: css-var(semanticColors-base-inverted-medium-iconOnBackground);
  border-radius: css-var(border-radius-max);
  width: 64px;
  height: 64px;
  position: css-var(play-icon-position);
  transform: css-var(play-icon-transform);
  top: css-var(play-icon-top);
  left: css-var(play-icon-left);
  opacity: css-var(play-icon-opacity);
  display: flex;
  justify-content: center;
  align-items: center;
}
